import React, { useRef, useState } from "react";
import styles from "./SignatureStatusRenderer.module.css";
import { Button, Overlay, Tooltip } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

/**
 * SignatureStatusRenderer Component
 */
const SignatureStatusRenderer: React.FC = (signature_status_props: any) => {
  const { SignatureStatus, SignatureMessage } = signature_status_props.data;
  const [showTooltip, setShowTooltip] = useState(false);
  const target = useRef(null);

  const handleClick = () => setShowTooltip((prev) => !prev);

  return SignatureStatus !== "" ? (
    <div className={styles.approvalStatusWrapper}>
      <span style={{ flexGrow: 1, textAlign: "left" }}>
        {SignatureStatus}
      </span>
      {SignatureMessage && (
        <>
          <Button
            className={styles.patchQuestionIcon}
            ref={target}
            onClick={handleClick}
          >
            <Icon.PatchQuestion />
          </Button>
          <Overlay
            target={target.current}
            show={showTooltip}
            placement="right"
            rootClose
            onHide={() => setShowTooltip(false)}
          >
            {(overlayProps: any) => (
              <Tooltip {...overlayProps} id="button-tooltip">
                {SignatureMessage}
              </Tooltip>
            )}
          </Overlay>
        </>
      )}
    </div>
  ) : null;
};

export default SignatureStatusRenderer;
